// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { Subscription } from 'rxjs';
import { ParameterController } from '../../../../_controller/parameter.controller';

import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SanitizeHtmlPipe } from 'src/app/modules/shared/pipes/sanitizeHTML.pipe';
import {
  ModalityModel,
  PortalWebAppConfiguration,
  SystemDetailsModel,
} from '../../../../api/remote-api/.portal.generated/models';
import { AnnouncementService } from '../../services/announcement-service';
import { PortalWebAppConfigurationService } from '../../services/portal-web-app-configuration.service';
import { SystemOverviewService } from '../../services/systemOverview.service';
import { ApplicationInsightsService } from '../../services/application-insights/application-insights-service/application-insights.service';
import { UserService } from '../../services/user.service';
import { User } from '@microsoft/microsoft-graph-types';

@Component({
  selector: 'app-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.css'],
  standalone: true,

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [RouterOutlet, AsyncPipe, SanitizeHtmlPipe, TranslateModule],
})
export class PortalComponent implements OnInit {
  mailParameter =
    '?subject=SeSO%20Portal%20reports%20an%20internal%20server%20error';
  private _portalWebAppConfiguration?: PortalWebAppConfiguration = undefined;

  get portalWebAppConfiguration(): PortalWebAppConfiguration {
    if (this._portalWebAppConfiguration === undefined) {
      this._portalWebAppConfiguration =
        this.configurationController.getPortalWebAppConfiguration();
    }
    return this._portalWebAppConfiguration;
  }

  currentSerialNrOrFuncLoc = '';
  currentSystemMaterialNumber = 0;
  currentModalityId = 0;
  currentTicketNumber = '';
  systemNotSupported = '';

  modalities?: ModalityModel[];
  notSupportedSystemDetails?: SystemDetailsModel;
  subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private configurationController: PortalWebAppConfigurationService,
    private parameterController: ParameterController,
    private systemOverviewService: SystemOverviewService,
    protected announcementService: AnnouncementService,
    private userService: UserService,
    private appInsights: ApplicationInsightsService,
  ) {}

  ngOnInit(): void {
    this.appInsightTrackDepartment();

    // this probably has to go, should be replaced by proper routing
    const searchTerm = this.parameterController.systemPassedByQueryParams(
      this.route.snapshot,
    );

    if (searchTerm) {
      // it would be better if the user would be sent to the correct page
      // directly
      this.router.navigateByUrl(
        `/system/${searchTerm.systemMaterialNumber}/${searchTerm.systemSerialNumber}?ticketNumber=${searchTerm.ticketNumber}`,
      );
    }
    this.systemOverviewService.modalities.request();
    this.systemOverviewService.announcement.request();
  }

  private appInsightTrackDepartment(): void {
    this.userService.userData$.subscribe((userData: User | undefined) => {
      this.appInsights.trackUserEvent('Users Department Details', {
        Department: userData?.department ?? 'unknown',
      });
    });
  }

  getSeSoMailAddress(): string {
    return `${this.portalWebAppConfiguration.seSOTeamMailAddress}${this.mailParameter}`;
  }
}
